export default __webpack_public_path__ + "static/media/sCurveLogo.5f0e080a.svg";